import { APP_URLS } from '../../routes/urls';
import { EligibleModule } from './types';

export const getCurrentEligibleModule = (pathname: string): EligibleModule => {
  if (pathname.startsWith(APP_URLS.eligiblePrograms)) {
    return 'Programs';
  } else if (pathname.startsWith(APP_URLS.eligibleScholarships)) {
    return 'Scholarships';
  } else {
    return 'Institutes';
  }
};
